// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import backend from "../backend";
const BASE_URI = "/accountdetails/";

export default {
  /**
   * Gets the AccountLabel from the backend server
   * @param {string} accountId - id of the account to retrieve
   * @param {boolean} includeDeleted - a value indicating whether it include deleted account
   * @returns {Promise<object>} AccountLabel
   */
  getAccountLabel(accountId: string, includeDeleted = false) {
    return backend.get(BASE_URI + accountId + "/label?includeDeleted=" + includeDeleted);
  },

  /**
   * Gets the addresses from the backend server
   * @param {string} accountId - id of the account to retrieve
   * @returns {Promise<Array>} List of addresses
   */
  getAddresses(accountId: string) {
    return backend.get(BASE_URI + accountId + "/addresses");
  },
};
